import React, { useState, useEffect } from 'react';
import { Box, Card, Typography, Table, TableContainer, Paper, Chip } from '@mui/material';
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout';
import EquipmentDropdown from '../../Inputs/EquipmentDropdown/EquipmentDropdown';
import { pathOr } from 'ramda';
import { HTTP_ENDPOINTS } from '../../../clients/clients.constants';
import { http } from '../../../clients/http/http.client';
import { useSelector, useDispatch } from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import DashboardEquipmentChartsContainer from "./DashboardEquipmentChartsContainer/DashboardEquipmentChartsContainer";
import EquipmentTable from "./DashboardEquipmentChartsContainer/EquipmnetTable/EquipmentTable";
import { DateTime } from "luxon";
import { setSelectedEquipments } from '../../../store/euqipmentFiltersSlice';
import CommonTable from "./DashboardEquipmentCommonTable/CommonTable/CommonTable";
import StoreHoursCard from "../DashboardPage/DashboardChartsContainer/StoreHoursCard/StoreHoursCard";
import e from "@chromatic-com/storybook";
import PeakUsageCard from "./PeakUsageCard/PeakUsageCard";
import {setStoreEquipmentTypeIds} from "../../../store/analyticsSelections";
import WeeklyPeakUsageChartCard from "./WeeklyPeakUsageChart/WeeklyPeakUsageChartCard";
import MonthlyPeakUsageChart from "./WeeklyPeakUsageChart/MonthlyPeakUsageChart";

const wereInUseDataColumns = [
    { label: "Entity Key", dataKey: "Entity_Key", width: 150 },
    { label: "Entity Type", dataKey: "Entity_type", width: 200 },
    { label: "Movements Count", dataKey: "UsageCount", width: 150 },
    { label: "Site Name", dataKey: "siteName", width: 200 },
    // { label: "Status", dataKey: "status", width: 200 },
    { label: "Tag ID", dataKey: "tagId", width: 200 },
];

const equipmentIsStockColumns = [
    // { label: "Entity Key", dataKey: "Entity_Key", width: 150 },
    { label: "Entity Type", dataKey: "Entity_type", width: 250 },
    { label: "Equipment Count", dataKey: "UsageCount", width: 250 },
    { label: "Site Name", dataKey: "siteName", width: 250 },
    // { label: "Equipment Count", dataKey: "UsageCount", width: 150 },
    // { label: "Tag ID", dataKey: "tagId", width: 200 },
];

const tripsDataColumns = [
    { label: "Entity Key", dataKey: "Entity_key", width: 150 },
    { label: "Entity Type", dataKey: "Entity_type", width: 200 },
    { label: "Tag ID", dataKey: "TagId", width: 200 },
    { label: "Site Name", dataKey: "siteName", width: 200 },
    { label: "Total Trips", dataKey: "TotalTrips", width: 150 },
    { label: "Opening Trips", dataKey: "OpeningTrips", width: 150 },
    { label: "Prior Trips", dataKey: "PriorTrips", width: 150 },
];

const tinTransitDataColumns = [
    { label: "Entity Key", dataKey: "Entity_key", width: 150 },
    { label: "Entity Type", dataKey: "equipmentType", width: 200 },
    { label: "Tag ID", dataKey: "tagId", width: 200 },
    { label: "Site Name", dataKey: "siteName", width: 200 },
    { label: "Status", dataKey: "status", width: 150 },
];

const DashboardEquipment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        EQUIPMENT_TYPES,
        GET_TRIPS_DATA,
        EQUIPMENT_LOCATIONS,
        GET_WERE_IN_USE_DATA,
        GET_IN_TRANSIT_DATA,
        EQUIPMENT_PEAK_USAGE,
        GET_SELECTED_EQUIPMENT_DATA
    } = HTTP_ENDPOINTS;
    const siteIdStore = useSelector((state) => state.siteId);
    const alertsDateFilters = useSelector((state) => state.actionsDateFilters);
    const timeZone = useSelector((state) => state.timeZone.timeZone);

    const equipmentTypeIds = useSelector(state => state.analyticsSelections.equipmentTypeIds);
    const dateRange = useSelector(state => state.analyticsSelections.dateRange);


    // State for dropdown options
    const [equipmentOptions, setEquipmentOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [fixtures, setFixtures] = useState(equipmentTypeIds);
    const [loadingEquipment, setLoadingEquipment] = useState(false);
    const [loadingLocations,   setLoadingLocations] = useState(false);
    const isLoading = loadingEquipment || loadingLocations;

    const [matHandling, setMatHandling] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(true);
    const [isMonthly, setIsMonthly] = useState(false);

    const dispatch = useDispatch();
    const toggleDrawer = () => setDrawerOpen(!drawerOpen);


    // Fetch equipment types on mount
    useEffect(() => {
        const fetchEquipmentTypes = async () => {
            try {
                setLoadingEquipment(true);
                const res = await http.client.get(`${EQUIPMENT_TYPES}/`);
                const equipmentTypes = pathOr([], ['equipmentTypes'], res);
                setEquipmentOptions(equipmentTypes);

              console.log(equipmentTypes);

                if (location.search.includes('shopping-carts')) {
                  setFixtures([1, 2])
                  setEquipmentOptions(equipmentTypes.filter((et) => [1, 2].includes(et.id)))
                }

                if (location.search.includes('fixtures')) {
                  setFixtures([5,6,7,8])
                  setEquipmentOptions(equipmentTypes.filter((et) => [5,6,7,8].includes(et.id)))
                }

                if (location.search.includes('backroom-material')) {
                  setFixtures([3, 4, 9, 10, 11, 12, 13, 14, 15])
                  setEquipmentOptions(equipmentTypes.filter((et) => [3, 4, 9, 10, 11, 12, 13, 14, 15].includes(et.id)))
                }

                if (location.search.includes('arrc-inventory') || !location.search) {
                  setFixtures([])
                }
              } catch (error) {
                  console.error('Error fetching equipment types:', error);
              } finally {
                 setLoadingEquipment(false);
              }
        };
        fetchEquipmentTypes();
    }, [location]);

    // useEffect(() => {
    //     const fetchEquipmentTypes = async () => {
    //         try {
    //             setLoadingEquipment(true);
    //             const res = await http.client.get(`${EQUIPMENT_TYPES}/`);
    //             const equipmentTypes = pathOr([], ['equipmentTypes'], res);
    //             setEquipmentOptions(equipmentTypes);
    //
    //             if (location.search.includes('shopping-carts')) {
    //                 setFixtures([1, 2])
    //                 setEquipmentOptions(equipmentTypes.filter((et) => [1, 2].includes(et.id)))
    //             }
    //
    //             if (location.search.includes('fixtures')) {
    //                 const selectedIds = [5, 6, 7, 8];
    //                 setFixtures(selectedIds);
    //                 dispatch(setStoreEquipmentTypeIds(selectedIds));
    //                 setEquipmentOptions(equipmentTypes.filter((et) => selectedIds.includes(et.id)));
    //             }
    //
    //             if (location.search.includes('backroom-material')) {
    //                 const selectedIds = [3, 4, 9, 10, 11, 12, 13, 14, 15];
    //                 setFixtures(selectedIds);
    //                 dispatch(setStoreEquipmentTypeIds(selectedIds));
    //                 setEquipmentOptions(equipmentTypes.filter((et) => selectedIds.includes(et.id)));
    //             }
    //
    //             if (location.search.includes('arrc-inventory') || !location.search) {
    //                 setFixtures([]);
    //                 dispatch(setStoreEquipmentTypeIds([]));
    //             }
    //         } catch (error) {
    //             console.error('Error fetching equipment types:', error);
    //         } finally {
    //             setLoadingEquipment(false);
    //         }
    //     };
    //     fetchEquipmentTypes();
    // }, [location, dispatch]);


    const handleFixturesChange = (selectedIds) => {
        setFixtures(selectedIds);
        dispatch(setStoreEquipmentTypeIds(selectedIds));
    };

    const handleMatHandlingChange = (selectedIds) => setMatHandling(selectedIds);

    const selectedEquipmentNames = fixtures
        .map((id) => {
            const equipment = equipmentOptions.find((eq) => eq.id === id);
            return equipment ? equipment.name : '';
        })
        .join(', ');

    // Determine view from URL query parameters
    const locationObj = useLocation();
    const queryParams = new URLSearchParams(locationObj.search);
    const view = queryParams.get("view"); // if view === 'trips', show trips summary

    const handleClearView = () => {
        queryParams.delete("view");
        // Navigate to the same pathname without the view parameter.
        navigate(`${locationObj.pathname}?${queryParams.toString()}`, { replace: true });
    };

    // useEffect(() => {
    //     if (view === "shopping-carts" && equipmentOptions.length > 0) {
    //         // Filter the equipment options by name.
    //         const preselected = equipmentOptions
    //             .filter(
    //                 (eq) =>
    //                     eq.name === "Shopping Cart Small Two-Tier" ||
    //                     eq.name === "Shopping Cart Large"
    //             )
    //             .map((eq) => eq.id);
    //         // Dispatch the selected equipment (using your Redux action)
    //         dispatch(setSelectedEquipments({ type: "equipment", value: preselected }));
    //     }
    // }, [view, equipmentOptions, dispatch]);

    // Fetch locations when site changes
    useEffect(() => {
        const fetchLocations = async () => {
            // if (!siteIdStore.siteId) return;
            setLoadingLocations(true);
            const params = new URLSearchParams();
            params.append('siteId', location.search.includes('arrc-inventory') ? 1 : siteIdStore.siteId);
            try {
                const response = await http.client.get(`${EQUIPMENT_LOCATIONS}?${params.toString()}`);
                setLocationOptions(response.data.map((location) => ({ id: location, name: location })));

                // Explicitly handle initial selection here
                if (view === "in-store") {
                    const inStoreOption = response.data.find(location => location.toLowerCase() === "in-store");
                    if (inStoreOption) {
                        setMatHandling([inStoreOption]);
                    } else {
                        setMatHandling([]);
                    }
                } else {
                    // Only reset if explicitly needed for other views
                    setMatHandling([]);
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
            } finally {
              setLoadingLocations(false);
            }
        };

        fetchLocations();
    }, [siteIdStore.siteId, view]);

  // const buildQueryParams = () => {
  //   let params = new URLSearchParams();
  //
  //   if (siteIdStore.siteId) {
  //     params.append('siteId', siteIdStore.siteId);
  //   }
  //
  //   if (location.search.includes('arrc-inventory')) {
  //     params.delete('siteId');
  //     params.append('siteId', location.search.includes('arrc-inventory') ? 1 : siteIdStore.siteId)
  //   }
  //
  //   if (fixtures && fixtures.length > 0) {
  //     const equipmentTypeIds = fixtures.join(',');
  //     params.append('equipmentTypeIds', equipmentTypeIds);
  //   }
  //
  //   return params.toString() ? `?${params.toString()}` : '';
  // };

    const buildQueryParams = () => {
        let params = new URLSearchParams();

        if (siteIdStore.siteId) {
            params.append('siteId', siteIdStore.siteId);
        }

        if (location.search.includes('arrc-inventory')) {
            params.delete('siteId');
            params.append('siteId', location.search.includes('arrc-inventory') ? 1 : siteIdStore.siteId);
        }

        // Use equipmentTypeIds from Redux
        if (equipmentTypeIds && equipmentTypeIds.length > 0) {
            params.append('equipmentTypeIds', equipmentTypeIds.join(','));
        }

        // Add date range if it exists
        if (dateRange?.start && dateRange?.end) {
            const fromISO = DateTime.fromJSDate(dateRange.start).startOf('day').toUTC().toISO();
            const toISO = DateTime.fromJSDate(dateRange.end).endOf('day').toUTC().toISO();
            params.append('from', fromISO);
            params.append('to', toISO);
        }

        return params.toString() ? `?${params.toString()}` : '';
    };


  useEffect(() => {
      const fetchPeakUsage = async () => {
        try {
          const params = buildQueryParams()
          const response = await http.client.get(`${EQUIPMENT_PEAK_USAGE}${params}`);
          console.log(response);
        } catch (error) {

        }
      }

      fetchPeakUsage()
    }, [siteIdStore.siteId, view, fixtures]);

    return (
        <DashboardLayout drawerOpen={drawerOpen} toggleDrawer={toggleDrawer}>
            <Box sx={{ gap: '20px', display: 'flex', flexDirection: 'column' }}>
                {/* Filters Section */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                        padding: '20px',
                        backgroundColor: '#F9FAFB',
                        borderRadius: '12px',
                        boxShadow: '0px 4px 40px rgba(226, 236, 249, 0.60)',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '24px',
                            fontWeight: '600',
                            color: '#1B3665',
                        }}
                    >
                        {selectedEquipmentNames || "All Equipment"}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: '20px' }}>
                        <EquipmentDropdown
                            type="default"
                            options={equipmentOptions}
                            selectedEquipment={fixtures}
                            handleSelectionChange={handleFixturesChange}
                            borderColor="#E0E0E0"
                            iconColor="#1B3665"
                            textColor="#1B3665"
                            width="200px"
                            placeholder="Select equipment"
                        />
                      {
                        view !== "in-transit" && (
                          <EquipmentDropdown
                            type="default"
                            options={locationOptions}
                            selectedEquipment={matHandling}
                            handleSelectionChange={handleMatHandlingChange}
                            borderColor="#E0E0E0"
                            iconColor="#1B3665"
                            textColor="#1B3665"
                            width="200px"
                            placeholder="Select location"
                          />
                        )
                      }
                        {/* Conditionally render the Chip if view is "trips" or "were-in-use" */}
                        {(view === "trips" || view === "were-in-use") && (
                            <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                                <Chip
                                    label={view === "trips" ? "Trips summary" : "Were in use"}
                                    variant="outlined"
                                    onClick={handleClearView}
                                    onDelete={handleClearView}
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        color: '#1B3665',
                                        borderColor: '#1B3665',
                                        '& .MuiChip-deleteIcon': {
                                            color: '#1B3665',
                                        },
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                </Box>

                {
                //     !siteIdStore.siteId ? (
                //     <Card sx={{ boxShadow: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', borderRadius: '12px' }}>
                //         <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "#1B3665" }}>
                //             Select Site to view equipment
                //         </Typography>
                //     </Card>
                // ) :
                        view === "trips" ? (
                    <>
                        <CommonTable
                            fixtures={fixtures}
                            matHandling={matHandling}
                            columns={tripsDataColumns}
                            dataEndpoint={GET_TRIPS_DATA}
                            siteId={siteIdStore.siteId}
                            tableName="Trips Summary"
                            dataType="trips"
                            downloadUrl={HTTP_ENDPOINTS.DOWNLOAD_TRIPS_REPORT}
                            defaultSort="Entity_key"
                        />
                    </>
                ) : view === "in-transit" ? (
                    <>
                        <CommonTable
                            fixtures={fixtures}
                            matHandling={matHandling}
                            columns={tinTransitDataColumns}
                            dataEndpoint={GET_IN_TRANSIT_DATA}
                            siteId={siteIdStore.siteId}
                            tableName="In transit Summary"
                            dataType="in-transit"
                            downloadUrl={HTTP_ENDPOINTS.DOWNLOAD_IN_TRANSIT_REPORT}
                        />
                    </>
                ) : view === "were-in-use" ? (
                    <>
                        <CommonTable
                            fixtures={fixtures}
                            matHandling={matHandling}
                            columns={wereInUseDataColumns}
                            dataEndpoint={GET_WERE_IN_USE_DATA}
                            siteId={siteIdStore.siteId}
                            defaultSort="UsageCount"
                            tableName="Were in use Summary"
                            dataType="were-in-use"
                            downloadUrl={HTTP_ENDPOINTS.DOWNLOAD_WERE_IN_USE}
                        />
                    </>
                ) : view === "selected-equipment" ? (
                    <>
                        <CommonTable
                            fixtures={fixtures}
                            matHandling={matHandling}
                            columns={equipmentIsStockColumns}
                            dataEndpoint={GET_SELECTED_EQUIPMENT_DATA}
                            siteId={siteIdStore.siteId}
                            defaultSort="UsageCount"
                            tableName="Selected equipment is stock"
                            dataType="equipment-in-stock"
                            downloadUrl={HTTP_ENDPOINTS.DOWNLOAD_EQUIPMENT_LOCATIONS_REPORT}
                        />
                    </>
                ) : view === "not-used" ? (
                    <>
                        <CommonTable
                            fixtures={fixtures}
                            matHandling={matHandling}
                            columns={wereInUseDataColumns}
                            dataEndpoint={GET_WERE_IN_USE_DATA}
                            siteId={siteIdStore.siteId}
                            tableName="Were in use Summary"
                            dataType="were-in-use"
                            downloadUrl={HTTP_ENDPOINTS.DOWNLOAD_WERE_IN_USE}
                        />
                    </>
                ) : (
                    <>
                      <Box sx={{display: 'flex', width: '100%', gap: 2}}>
                        {
                          location.search.includes('shopping-carts') ? (
                            <>
                              {isMonthly ? (
                                <MonthlyPeakUsageChart
                                  monthlyPeakUsages={[]}
                                  timeZone={timeZone}
                                />
                              ) : (
                                <StoreHoursCard />
                              )}
                              {
                                siteIdStore.siteId && (
                                  <Box sx={{ gap: '10px!important', display: 'flex', flexDirection: 'column' }}>
                                    <PeakUsageCard
                                      siteId={siteIdStore.siteId}
                                      fixtures={fixtures}
                                      view={view}
                                      navigatePath="/equipment/peak-usage/details"
                                    />
                                    <WeeklyPeakUsageChartCard
                                      siteId={siteIdStore.siteId}
                                      fixtures={fixtures}
                                      isMonthly={isMonthly}
                                      setIsMonthly={setIsMonthly}
                                    />
                                  </Box>
                                )
                              }
                            </>

                          ) : (
                            <DashboardEquipmentChartsContainer
                              fixtures={fixtures}
                              matHandling={matHandling}
                            />
                          )
                        }
                      </Box>
                        <EquipmentTable
                            fixtures={fixtures}
                            matHandling={matHandling}
                            isMovements
                            externalLoading={isLoading}
                        />
                    </>
                )}
            </Box>
        </DashboardLayout>
    );
};

export default DashboardEquipment;
